"use client";

/**
 * @bookwriter/ink-paper-ui
 * Ink & Paper — BookWriter's React component library.
 *
 * Usage:
 *   import { Button, Card, SceneCard } from "@bookwriter/ink-paper-ui";
 *   import "@bookwriter/ink-paper-ui/styles.css";
 */

// Theme + utilities
export { setTheme, getTheme, toggleTheme, type Theme } from "./theme.js";
export { cx, initials } from "./util.js";

// Typography
export {
  Display, Heading, Text, Reading, Mono, Eyebrow,
  type DisplayProps, type HeadingProps, type TextProps, type ReadingProps, type MonoProps, type EyebrowProps,
} from "./components/Typography.js";

// Controls
export { Button, type ButtonProps, type ButtonVariant, type ButtonSize } from "./components/Button.js";
export {
  Field, Input, Textarea, Select,
  type FieldProps, type InputProps, type TextareaProps, type SelectProps, type SelectOption,
} from "./components/Form.js";

// Data display
export { Badge, StatusBadge, type BadgeProps, type BadgeVariant, type StatusBadgeProps, type SceneStatus } from "./components/Badge.js";
export { Chip, Tag, codexTypeColor, type ChipProps, type TagProps, type CodexType } from "./components/Chip.js";
export { Tabs, type TabsProps, type TabItem } from "./components/Tabs.js";
export { Card, CardHeader, CardBody, type CardProps, type CardHeaderProps, type CardBodyProps } from "./components/Card.js";
export { Avatar, type AvatarProps } from "./components/Avatar.js";
export { ProgressBar, type ProgressBarProps } from "./components/ProgressBar.js";

// Layout / app shell
export { SidebarNav, NavItem, type SidebarNavProps, type NavItemProps } from "./components/Nav.js";
export { StatCard, type StatCardProps } from "./components/StatCard.js";

// Domain
export { ProjectCard, type ProjectCardProps } from "./components/ProjectCard.js";
export { SceneCard, type SceneCardProps } from "./components/SceneCard.js";
export { EntityMention, ProgressionBlock, type EntityMentionProps, type ProgressionBlockProps } from "./components/Manuscript.js";
